<template>
  <footer class="vueFootern" style="padding:0 0 0;">
    <div class="Copyright">
      <dl class="w1400 clearfix">
        <dd class="fl">
          <p class="nav"><a href="#">{{ $t('footer.legal') }}</a> | <a href="#">{{ $t('footer.sitemap') }}</a> | <a href="#">{{ $t('footer.links') }}</a></p>
          <p>Copyright © 2024 {{ $t('footer.copyright') }} <img alt="" src="static/picture/f-ico1.png">
            <a href="#"> </a>

            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{ $t('footer.beian') }}</a>


            {{ $t('footer.filingPrefix') }}<a href="https://beian.miit.gov.cn" target="_blank">{{ $t('footer.icp') }}</a>
          </p>
        </dd>
        <dd class="fr">Designed by Bio-Coupling Medical Lab</dd>
      </dl>
    </div>
  </footer>

</template>
<script>
export default {
  name: 'MemberFooter'
};
</script>

<style scoped>
@import url(@/components/static/css/footern.css);

</style>